import { FormikHelpers } from "formik";

type SubmitHandler<Values> = (
  values: Values,
  helpers: FormikHelpers<Values>,
) => Promise<void>;

function useFormikStatusSubmit<Values>(onSubmit: SubmitHandler<Values>) {
  return async (values: Values, helpers: FormikHelpers<Values>) => {
    try {
      helpers.setStatus({ type: "submitting" });
      await onSubmit(values, helpers);
      helpers.setStatus({ type: "success" });
    } catch (error) {
      helpers.setStatus({ type: "error", error });
      throw error;
    }
  };
}

export default useFormikStatusSubmit;
